import { render, staticRenderFns } from "./RBtn.vue?vue&type=template&id=43abaec6&"
import script from "./RBtn.vue?vue&type=script&lang=js&"
export * from "./RBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports